import { useLayoutEffect, useRef } from "react";

export default function FilmStrip({ children, className = "" }) {
  const ref = useRef(null);

  useLayoutEffect(() => {
    function setAngle() {
      const el = ref.current;
      if (!el) return;

      /* how much the edge drops (—p) divided by the real width */
      const p = parseFloat(getComputedStyle(el).getPropertyValue("--p"));
      const w = el.offsetWidth;
      const angle = -(Math.atan(p / w) * 180) / Math.PI; // deg, negative

      /* 🔑  stash it so CSS can pick it up */
      el.style.setProperty("--angle", `${angle}deg`);
    }

    setAngle(); // initial
    window.addEventListener("resize", setAngle); // keep it responsive
    return () => window.removeEventListener("resize", setAngle);
  }, []);

  return (
    <section
      ref={ref}
      /* safe fallback before JS runs               ↓↓↓ */
      style={{ "--angle": "-7deg" }}
      className={`film-strip-section ${className}`}
    >
      {children}
    </section>
  );
}
